import {
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';

@Component({
    selector: 'agpr-common-component-reader',
    templateUrl: './common-component-reader.component.html',
    styleUrls: ['./common-component-reader.component.scss'],
    standalone: false,
})
export class CommonComponentReaderComponent {
    @Input() id: string = '';
    @Input() key: string;
    @Input() data: any;
    @Output() viewAllMentionsClicked = new EventEmitter<void>();
    @Input() displayAutomateImagePlaceholder: boolean;
    @Input() includeEmptySections: boolean = true;
    @Input() showErrors: boolean = true;
    @Input() isPublished: boolean = false;
    // Reference point for resolving relative date ranges (e.g. LAST_QUARTER) on the date
    // block — typically the briefing's send time. Forwarded to agpr-date-display.
    @Input() referenceDate: Date | number;
    // Whether the date block renders the recurrence placeholder for a RECURRENCE-based range.
    // Enabled by default (core app); the bmie renderer binds this to false. Forwarded to
    // agpr-date-display.
    @Input() showRecurrenceDateRangePlaceholder: boolean = true;

    constructor() {}

    viewAllMentions() {
        this.viewAllMentionsClicked.emit();
    }
}
